import React, { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { AgGridReact } from "@ag-grid-community/react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import exportsvg from "../../assets/images/admin/dashboard/export.svg";
import { apiUrl } from "../../config/Config";

ModuleRegistry.registerModules([ClientSideRowModelModule]);

const Subscribers = () => {
  const navigate = useNavigate();
  const userdata = useSelector((store) => store.userReducer.userdata);
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);
  const paginationPageSizeSelector = useMemo(() => [10, 20, 50, 100], []);

  const formatDate = (dateValue) => {
    if (!dateValue) return "NA";
    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) return dateValue;
    return new Intl.DateTimeFormat("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(date);
  };

  const fetchSubscribers = useCallback(async () => {
    setLoading(true);
    await axios
      .post(
        apiUrl + "getadminsubscribers",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + userdata?.token,
          },
        }
      )
      .then((res) => {
        if (res.data.status === "success") {
          setSubscribers(Array.isArray(res.data.data) ? res.data.data : []);
        } else {
          Swal.fire({
            text: res.data.message,
            icon: "error",
            confirmButtonColor: "rgb(59, 151, 196)",
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          text: err.message,
          icon: "error",
          confirmButtonColor: "rgb(59, 151, 196)",
        });
      });
    setLoading(false);
  }, [userdata?.token]);

  useEffect(() => {
    if (userdata && Object.keys(userdata).length > 0) {
      fetchSubscribers();
    } else {
      navigate("/admin/login");
    }
  }, [fetchSubscribers, navigate, userdata]);

  const rowData = useMemo(
    () =>
      subscribers.map((subscriber) => ({
        id: subscriber.id,
        email: subscriber.email || "NA",
        status: subscriber.status || "active",
        source: subscriber.source || "footer",
        subscribedAt: formatDate(subscriber.subscribed_at || subscriber.created_at),
        created: formatDate(subscriber.created_at),
      })),
    [subscribers]
  );

  const colDefs = useMemo(
    () => [
      { field: "email", headerName: "Email", filter: true, flex: 1.8 },
      { field: "source", headerName: "Source", filter: true },
      { field: "subscribedAt", headerName: "Subscribed Date" },
      { field: "created", headerName: "Created" },
      {
        field: "status",
        headerName: "Status",
        cellRenderer: (props) => (
          <div className={`orderstatusbg ${props.data.status === "active" ? "completed" : "cancelled"}`}>
            <p>{props.data.status}</p>
          </div>
        ),
      },
    ],
    []
  );

  return (
    <div>
      <div className="dashboardbox" style={{ width: "100%" }}>
        <div className="productstogglebar mt-2">
          <p className="dashboardboxsubtitle">
            {loading ? "Loading subscribers..." : `${rowData.length} subscribers found`}
          </p>
          <div className="filterdiv" style={{ marginLeft: "auto" }}>
            <img src={exportsvg} className="orderexporticon" alt="" />
            <p>{loading ? "Loading..." : `${rowData.length} Subscribers`}</p>
          </div>
        </div>

        <div className="ag-theme-quartz mt-4" style={{ width: "100%", height: 550 }}>
          <AgGridReact
            rowData={rowData}
            columnDefs={colDefs}
            defaultColDef={{ flex: 1 }}
            suppressRowClickSelection={true}
            groupSelectsChildren={true}
            rowSelection={"multiple"}
            pagination={true}
            paginationPageSize={10}
            paginationPageSizeSelector={paginationPageSizeSelector}
            rowHeight={50}
          />
        </div>
      </div>
    </div>
  );
};

export default Subscribers;
